var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"svgicon",class:_vm.iconClass,attrs:{"data-icon":_vm.iconClass},domProps:{"innerHTML":_vm._s(_vm.iconHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }